module.exports = "/img/_/_/_/assets/images/creeper/battle/common//34.jpg?3a53f0cac8b5e51a55062d638b3d86cb";